module.exports = __webpack_public_path__ + "static/img/mypage__top__img.06c7dfac.svg";